import { Capacitor } from '@capacitor/core';

export function isNativeApp() {
  try {
    if (typeof Capacitor?.isNativePlatform === 'function') {
      return Capacitor.isNativePlatform();
    }
    return Capacitor.getPlatform && Capacitor.getPlatform() !== 'web';
  } catch {
    return false;
  }
}
